import React, { useState, useEffect } from 'react'
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import { SlDrawer, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { useFormik } from "formik";
import api from "../../services/api";
import { formatDateWithTime } from '../../utils/dateFormat';
import NoDataFound from '../../shared/NoDataFound';
import { Toast } from '../../shared/Toast';
import Paginator from '../../shared/Paginator';
import config from '../../config';
import TableLoader from '../../shared/TableLoader';
import { useSelector } from 'react-redux';
import { debounce } from '../../utils/Debounce';
import { SlTooltip, SlIconButton, SlButton } from '@shoelace-style/shoelace/dist/react';
import { langoptions } from '../../utils/constants';
import "../creatives/CreativeList.scss";


const initialEditions = {
    language: '',
    edition_name: ''
}
let initialValues = JSON.parse(JSON.stringify(initialEditions));


const EditionSchema = Yup.object().shape({
    language: Yup.string().required('Language is required'),
    edition_name: Yup.string().required('Edition is required'),

})


function Editions() {

    const navigate = useNavigate()

    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [flag, setFlag] = useState('')
    const [id, setId] = useState('');
    const [search, setSearch] = useState("")

    const [totalPages, setTotalPages] = useState(0);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        loadData(search, event.selected);
    };
    const HeaderSearch = useSelector(state => state.Head.adssearch)

    const handleClose = () => {
        setShow(false);
        setSubmit(false);
        initialValues = JSON.parse(JSON.stringify(initialEditions));
        formik.setValues(initialValues);
    }

    const handleShow = (choose, item) => {
        if (choose === "add") {
            formik.setValues(item);
            setShow(true);
        }
        if (choose === 'edit') {
            initialValues.language = item.language
            initialValues.edition_name = item.edition_name
            formik.setValues(initialValues);
            setShow(true)
        }
    };

    useEffect(() => {
        Header()
    }, [HeaderSearch])

    const loadData = async (searchString = '', page = 0) => {
        try {
            setLoader(true);
            let res = await api({
                url: `/birdview/getEditions`,
                method: "POST",
                responseType: "json",
                data: {
                    page,
                    limit: config.PER_PAGE,
                    search: searchString
                }
            });
            setData(res.data.data.length ? res.data.data : [])
            setTotal(res.data.total || 0);
            setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
            setLoader(false);
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const Header = () => {
        setSearch(HeaderSearch);
        setCurrentPage(0);
        loadData(HeaderSearch, 0);
    }

    const searchData = e => {
        setSearch(e.target.value);
        setCurrentPage(0);
        loadData(e.target.value, 0);
    }
    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }

    let formik = useFormik({
        initialValues: JSON.parse(JSON.stringify(initialEditions)),
        validationSchema: EditionSchema,
        onSubmit: async (values) => {
            if (flag === 'add') {
                try {
                    let res = await api({
                        url: `/birdview/addEdition`,
                        method: "POST",
                        responseType: "json",
                        data: values
                    });
                    if (res?.data?.code === 500) {
                        Toast('error', res.data.message);
                    } else {
                        Toast("success", "Edition Added Successfully");
                        handleClose();
                        setCurrentPage(0);
                        setSearch('');
                        loadData(search, 0);
                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
            if (flag === 'edit') {
                try {
                    let res = await api({
                        url: `/birdview/editEdition/${id}`,
                        method: "PUT",
                        responseType: "json",
                        data: values
                    });
                    if (res?.data?.code === 500) {
                        Toast('error', res.data.message);
                    } else {
                        Toast("success", "Edition updated Successfully");
                        handleClose()
                        loadData(search, currentPage);
                        values.edition_name = ''
                        values.language = ''


                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
        }
    });
    const getLanguageNameByCode = (language) => {
        const lang = langoptions.find(option => option.value === language);
        return lang ? lang.label : 'Unknown';
    };

    return (
        <>
            <div className="creativeListPage flex flex-col h-[calc(100vh-72px)]">
              <div className="cl-card flex min-h-0 flex-1 flex-col">
                <header className="cl-header shrink-0">
                  <div className="cl-title-block">
                    <h1 className="cl-title">Editions</h1>
                    <p className="cl-subtitle">{data?.length || 0} editions</p>
                  </div>
                  <div className="cl-toolbar cl-toolbar--inline">
                    <SlInput className="cl-search" size="medium" id="myInput" onSlInput={debounce(searchData, 500)} placeholder="Search by name">
                        <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                    </SlInput>
                    <SlButton size="medium" variant="primary" onClick={() => { handleShow("add", {}); setFlag('add') }}>
                        <SlIcon library="lucide" name="plus" slot="prefix"></SlIcon>
                        Add Edition
                    </SlButton>
                  </div>
                </header>
            <SlDrawer label="Add Edition" open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} >
                <form onSubmit={formik.handleSubmit}>
                    {/* Language */}
                    <div className="mb-3">
                        <label className="mb-1">Language</label><span className="text-red-600">*</span>
                        <select
                            className="form-select"
                            aria-label="Select Language"
                            name="language"
                            onBlur={formik.handleBlur}
                            value={`${formik.values.language}`}
                            onChange={(e) => {
                                formik.setFieldValue("language", e.target.value);
                            }}
                        >
                            <option value="">Select Language</option>
                            {langoptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                        {submit && formik.errors.language ? (
                            <div className="text-red-600">{formik.errors.language}</div>
                        ) : null}
                    </div>

                    {/* Edition Name */}
                    <div className="mb-3">
                        <label className="mb-1"> Edition Name</label><span className="text-red-600">*</span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Edition Name"
                            aria-label=""
                            name="edition_name"
                            value={formik.values.edition_name}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.edition_name ? (
                            <div className="text-red-600	">{formik.errors.edition_name}</div>
                        ) : null}
                    </div>


                    <div slot="footer">
                        <SlButton
                            type="submit"
                            variant="primary"
                            size="small"
                            onClick={(e) => setSubmit(true)}>Submit</SlButton>
                    </div>

                </form>
            </SlDrawer>

                <div className="cl-table-wrap flex-1 min-h-0 overflow-y-auto">
                    <table className="cl-table cl-table--multi">
                        <thead>
                            <tr>
                                <th>Edition Name</th>
                                <th>Language</th>
                                <th>Created Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        {(data?.length && !loader) ? (
                            <tbody>
                                {data.map((item) => (
                                    <tr key={item.edition_id}>
                                        <td className="cl-name" data-label="Edition Name">{item.edition_name}</td>
                                        <td data-label="Language">
                                            <span className="inline-flex items-center rounded-md bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600">{getLanguageNameByCode(parseInt(item.language))}</span>
                                        </td>
                                        <td data-label="Created Date">{formatDateWithTime(item.created_on)}</td>
                                        <td data-label="Actions">
                                            <div className="cl-actions">
                                                <SlTooltip content="Edit Edition">
                                                    <SlIconButton
                                                        library="lucide"
                                                        name="edit"
                                                        onClick={() => { handleShow("edit", item); setFlag('edit'); setId(item.edition_id) }}></SlIconButton>
                                                </SlTooltip>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>) : ((!data?.length && !loader)
                                ? <NoDataFound colspan="4" />
                                : <TableLoader colspan="4" />
                        )
                        }
                    </table>
                </div>
                {totalPages > 1 && (
                  <div className="cl-pagination shrink-0 !justify-between">
                    <span className="self-center text-sm text-slate-500">Showing {data?.length || 0} of {total} editions</span>
                    <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />
                  </div>
                )}
              </div>
            </div>
        </>
    )
}

export default Editions